import React from 'react';
import { Link } from 'react-router-dom';

/** Landing spot after a real Stripe Checkout completes. The actual member
 * record/magic-link email is created by the checkout.session.completed
 * webhook (stripe.controller.js) — this page is just the "you're in" moment. */
export default function JoinSuccess() {
  return (
    <div className="min-h-screen bg-reset-cream flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-sm p-8 text-center">
        <h1 className="font-serif text-3xl font-bold text-reset-brown mb-3">You're in.</h1>
        <p className="text-sm text-gray-500 mb-6">
          Welcome to Reset Your Life in 365 Days. Check your email in the next few minutes for a link to set up your account.
        </p>
        <Link to="/auth/login" className="text-sm font-medium text-reset-terracotta hover:underline">
          Already have your login? Sign in →
        </Link>
      </div>
    </div>
  );
}
